import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const modalHeader = css`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  grid-row-start: header-start;
  grid-row-end: header-end;
  padding: ${theme.spacing(0, 3)};
`;

export const modalHeaderHeading = css`
  margin: 0;
`;

export const modalHeaderCloseButton = css`
  align-self: baseline;
`;

export const modalLabel = css`
  margin: 0;
  padding: ${theme.spacing(0, 3)};
  grid-row-start: label-start;
  grid-row-end: label-end;
`;
